import React, { useEffect, useState } from "react";
import "./SingleEvent.scss";
import moment from "moment";
import { Col, Dropdown } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { eventByIdApi, showId } from "../../../store/actions/eventActions";
import { geteventStatus } from "../../../store/actions/statusActions";
import {
  getInvitedUsers,
  getUserList,
} from "../../../store/actions/userActions";
import Attachment from "../../Attachments/attachment";
import ShareModal from "../../Modal/Share/Sharemodal";
import UserList from "../../Modal/userList/userList";
import Sharefriends from "../../shareFrnds/shareFriends";
import Invited from "../../Modal/invited/invited";
import { useTranslation } from "react-i18next";
import NewEvent from "../../Modal/newEvent/newEvent";
import LoginModal from "../../Modal/Login/LoginModal";
import { ImLocation } from "react-icons/im";
import { FaEdit } from "react-icons/fa";
import { TiLocationArrow } from "react-icons/ti";
import { ReactComponent as PublicIcon } from "../../../img/icons/public.svg";
import { ReactComponent as PrivateIcon } from "../../../img/icons/private.svg";
import { ReactComponent as TickIcon } from "../../../img/icons/tick.svg";
import { ReactComponent as ShareIcon } from "../../../img/icons/share.svg";
import { ReactComponent as CalendarIcon } from "../../../img/icons/calendar.svg";
import { ReactComponent as ClockIcon } from "../../../img/icons/clock.svg";
import { ReactComponent as LocationIcon } from "../../../img/icons/location.svg";
import { ReactComponent as CallIcon } from "../../../img/icons/call.svg";
import { ReactComponent as SmsIcon } from "../../../img/icons/sms.svg";
import Helmetcomponent from "../../Helmet/helmetcomponent";
import { FaEarthAmericas } from "react-icons/fa6";
import { PiUsersFill } from "react-icons/pi";
import httpService from "../../../common/http.service";


const SingleEvent = () => {
  const eventId = useParams();
  const { t } = useTranslation();
  const userData = useSelector((state) => state?.user);
  const token = localStorage.getItem("token");
  const dispatch = useDispatch();
  const event = useSelector(showId);
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const [showUserList, setShowUserList] = useState(false);
  const handleCloseUserList = () => setShowUserList(false);
  const handleShowUserList = () => setShowUserList(true);
  const [showInvited, setShowInvited] = useState(false);
  const handleCloseInvited = () => setShowInvited(false);
  const handleShowInvited = () => setShowInvited(true);
  const [status, setStatus] = useState("");
  const userList = useSelector((state) => state?.SearchUser?.userlist);
  const invitedUsers = useSelector((state) => state?.SearchUser?.invited);
  const latlong = JSON.parse(localStorage.getItem("location"));
  const [showCreate, setShowCreate] = useState(false);
  const handleCloseCreate = () => setShowCreate(false);
  const handleShowCreate = () => setShowCreate(true);
  const [selectedEvent, setSelectedEvent] = useState("");
  const [showLogin, setShowLogin] = useState(false);
  const handleCloseLogin = () => setShowLogin(false);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    const eventData = {
      eventId: eventId?.id,
      userId: userData?.userId,
    };
    dispatch(eventByIdApi(eventData));
  }, [eventId, dispatch, userData?.userId]);

  useEffect(() => {
    if (token && !event?.isPrivate && status) {
      const data = {
        eventId: eventId?.id,
        usersId: userData?.userId,
        status: status.toLowerCase(),
      };
      dispatch(geteventStatus(data));
    }
  }, [status]);

  
  useEffect(() => {
    if(eventId?.id) {
      fetchattendingusers();
    }
  },[token]);

  const fetchattendingusers = async () => {
    const data = {
      eventId: eventId?.id,
      user: true,
      status: "attending",
    };
    try {
      const response = await httpService.get(
        `eventparticipant/${data.eventId}?user=${data.user}&status=${data.status}&userId=${userData.userId}`
      );
      if (response && response.data) {
        const isUserAttending = response.data.some(
          item => item.usersId?._id === userData.userId && item.status === "attending"
        );
        if (isUserAttending) {
          setStatus("Attending");
        }
      }
    } catch (err) {
      console.error("Error fetching attending users", err);
    }
  };

  function handleUserList() {
    const data = {
      eventId: eventId?.id,
      user: true,
      status: "attending",
      userId: userData?.userId,
    };
    dispatch(getUserList(data));
  }
  function handleInvitedUsers() {
    const data = {
      eventId: eventId?.id,
      user: true,
      status: "invited",
    };
    dispatch(getInvitedUsers(data));
  }
  const title=event?.title


  return (
    <>
      <div
        style={{
          padding: "3%",
          marginTop: "1.46vw",
          backgroundColor: "#FFE8D8",
        }}
        className=" font-poppins"
      >
        <Helmetcomponent index={"SingleEvent"} path={eventId.id} data={title}/>        
        <div className="d-flex flex-column flex-sm-column flex-md-column flex-lg-col  gap-4 ">
          <div className="relative w-full" style={{ paddingTop: "50%" }}>
            <img
              src={event?.imageURL}
              alt=""
              className="absolute top-0 left-0 w-full h-full object-cover"
            />
            {/* Gradient Overlay */}
            <div className="absolute bottom-0 left-0 w-full h-3/4 bg-gradient-to-t from-black to-transparent"></div>

            {/* Title Over Image */}
            <div className="absolute bottom-8 left-8 text-white font-poppins">
              <h3
                className="text-xl md:text-2xl font-semibold"
              >
                {event?.title}
              </h3>
            </div>
          </div>
          <div className="relative w-full" style={{}}>
          </div>
          <div className="d-flex justify-content-between flex-column flex-sm-row flex-md-row flex-lg-row flex-xl-row gap-5 font-poppins">
          <div className="d-flex gap-2  align-items-center">
            <div
              className="event-type-button fs-4  d-flex justify-content-center align-items-center"
              style={{
                background: `${event?.categoryId?.categoryName === "Social Event"
                  ? "#85D3FF"
                  : event?.categoryId?.categoryName === "Temple Event"
                    ? "#7EFD5E"
                    : event?.categoryId?.categoryName === "Family Event"
                      ? "#FF8FE0"
                      : event?.categoryId?.categoryName === "Prayer Event" &&
                      "#CBFF37"
                  }`,
              }}
            >
              {event?.categoryId?.categoryName}
            </div>
            
          </div>

          <div className="d-flex gap-3 justify-content-center align-items-center">
              <div className="">
                {event?.isPrivate ? (
                  <PiUsersFill style={{
                    height: "65px", width: "65px", background: "#483F50",padding: "10px",
                    borderRadius: "10px",
                    color: "white",
                  }} />
                ) : (
                  <FaEarthAmericas style={{
                    height: "65px", width: "65px", background: "#483F50",padding: "10px",
                    borderRadius: "10px",
                    color: "white",
                  }} />
                )}
              </div>
            <div>
            <button
              style={{
                background: "#483F50",
                borderRadius: "10px",
                height: "65px",
                width: "65px",
                border: 0,
              }}
              className="d-flex justify-content-center align-items-center"
            >
              <TickIcon style={{ height: "40px" }} />
            </button>
            </div>

            <button
              style={{
                background: "#483F50",
                borderRadius: "10px",
                height: "65px",
                width: "65px",
                border: 0,
              }}
              className="d-flex justify-content-center align-items-center"
            >
              <ShareIcon style={{ height: "40px" }} />
            </button>
          </div>
        </div>
          <div className="d-flex flex-column justify-content-between">
            <div className="d-flex flex-column ">
              <h1
                className="text-2xl font-semibold"
              >
                {t("Description")}
              </h1>
              <pre className="mb-4 text-lg font-poppins whitespace-pre-wrap">
                {event?.description}
              </pre>
            </div>
            <div className="d-flex gap-3 mb-2">
              <div
                className="d-flex justify-content-center align-items-center"
                style={{
                  height: "30px",
                  width: "30px",
                  borderRadius: "10px",
                  background: `${event?.categoryId?.categoryName === "Social Event"
                    ? "#85D3FF"
                    : event?.categoryId?.categoryName === "Temple Event"
                      ? "#7EFD5E"
                      : event?.categoryId?.categoryName === "Family Event"
                        ? "#FF8FE0"
                        : event?.categoryId?.categoryName === "Prayer Event" &&
                        "#CBFF37"
                    }`,
                }}
              >
                <CalendarIcon
                  style={{
                    height: "20px",
                    width: "20px",
                  }}
                />
              </div>
              <span className="font-poppins text-lg" >
                {moment(event?.startDate).format("dddd, MMM Do")} -{" "}
                {moment(event?.endDate).format("MMM Do yyyy")}
              </span>
            </div>
            <div className="d-flex gap-3 mb-2">
              <div
                className="d-flex justify-content-center align-items-center"
                style={{
                  height: "30px",
                  width: "30px",
                  borderRadius: "10px",
                  background: `${event?.categoryId?.categoryName === "Social Event"
                    ? "#85D3FF"
                    : event?.categoryId?.categoryName === "Temple Event"
                      ? "#7EFD5E"
                      : event?.categoryId?.categoryName === "Family Event"
                        ? "#FF8FE0"
                        : event?.categoryId?.categoryName === "Prayer Event" &&
                        "#CBFF37"
                    }`,
                }}
              >
                <ClockIcon
                  style={{
                    height: "20px",
                    width: "20px",
                  }}
                />
              </div>
              <span className="font-poppins text-lg" >
                {event?.startTime} - {event?.endTime}
              </span>
            </div>
            <div className="d-flex gap-3  mb-4">
              <div
                className="d-flex justify-content-center align-items-center"
                style={{
                  height: "30px",
                  width: "30px",
                  borderRadius: "10px",
                  background: `${event?.categoryId?.categoryName === "Social Event"
                    ? "#85D3FF"
                    : event?.categoryId?.categoryName === "Temple Event"
                      ? "#7EFD5E"
                      : event?.categoryId?.categoryName === "Family Event"
                        ? "#FF8FE0"
                        : event?.categoryId?.categoryName === "Prayer Event" &&
                        "#CBFF37"
                    }`,
                }}
              >
                <LocationIcon
                  style={{
                    height: "20px",
                    width: "30px",
                  }}
                />
              </div>
              <span
                className="font-poppins text-lg text-decoration-underline "
                style={{ fontSize: "20px" }}
              >
                {event?.address}
              </span>
            </div>
            {token &&
              !event?.isPrivate &&
              !event?.userStatus &&
              event?.usersId?._id !== userData?.userId &&
              moment(new Date()).format("yyyy-MM-DD") <
              moment(event?.endDate).format("yyyy-MM-DD") ? (
              <div className="d-flex align-items-center event-status-div">
                <span className="event-status-heading">Status</span>
                <span>
                  <Dropdown>
                    <Dropdown.Toggle
                      id="dropdown-basic"
                      className="dropdown-button event-status-value"
                      drop="down"
                    >
                      {!status ? "Select Status" : status}
                    </Dropdown.Toggle>
                    <Dropdown.Menu
                      style={{
                        border: "unset",
                        borderRadius: "unset",
                        width: "100%",
                      }}
                    >
                      <Dropdown.Item
                        href="#"
                        onClick={() => setStatus("Attending")}
                      >
                        Attending
                      </Dropdown.Item>
                      <Dropdown.Item
                        href="#"
                        onClick={() => setStatus("Not Attending")}
                      >
                        Not Attending
                      </Dropdown.Item>
                      <Dropdown.Item
                        href="#"
                        onClick={() => setStatus("May be Attending")}
                      >
                        May be attending
                      </Dropdown.Item>
                    </Dropdown.Menu>
                  </Dropdown>
                </span>
              </div>
            ) : moment(new Date()).format("yyyy-MM-DD") >
              moment(event?.endDate).format("yyyy-MM-DD") ? (
              <div>
                <span className="font-poppins text-xl font-semibold">Event is Ended</span>
              </div>
            ) : (
              event?.userStatus && (
                <div className="d-flex event-status-div">
                  <span className="event-status-heading">Status</span>
                  <span className="event-status-value">{event?.userStatus}</span>
                </div>
              )
            )}
            <div className="d-flex justify-content-start gap-4 mb-5 mt-3 ">
              <button
                className="border-0 font-poppins text-white text-xl"
                id="eventRegister"
                onClick={() => {
                  if (!token) {
                    setShowLogin(true);
                  } else {
                    handleUserList();
                    handleShowUserList();
                  }
                }}
                style={{
                  height: "85px",
                  width: "170px",
                  borderRadius: "10px",
                  background: "#483F50",
                }}
              >
                {t("Event_Participants")}
              </button>
              <button
                className="border-0 font-poppins text-white text-xl"
                style={{
                  height: "85px",
                  width: "170px",
                  borderRadius: "10px",
                  background: "#483F50",
                }}
                onClick={() => {
                  if (!token) {
                    setShowLogin(true);
                  } else {
                    handleInvitedUsers();
                    handleShowInvited();
                  }
                }}
              >
                {t("Invited_Users")}
              </button>
            </div>
            {!token &&
              moment(new Date()).format("yyyy-MM-DD") <
              moment(event?.endDate).format("yyyy-MM-DD") && (
                <button
                  className="border-0 montserrat-font text-white w-100"
                  style={{
                    cursor: "pointer",
                    height: "90px",
                    borderRadius: "10px",
                    background: "#EB7625",
                  }}
                  onClick={() => !token && setShowLogin(true)}
                >
                  Login to Attend
                </button>
              )}
            {event?.usersId?._id === userData?.userId &&
              moment(new Date()).format("yyyy-MM-DD") <
              moment(event?.endDate).format("yyyy-MM-DD") && (
                <div>
                  <button
                    className="border-0 montserrat-font text-white w-100"
                    style={{
                      cursor: "pointer",
                      height: "90px",
                      borderRadius: "10px",
                      background: "#EB7625",
                    }}
                    onClick={() => {
                      handleShowCreate();
                      setSelectedEvent(event);
                    }}
                  >
                    <div className="d-flex justify-content-center align-items-center gap-1">
                      <FaEdit className="fs-4"></FaEdit>
                      <span className="fs-4">Edit Event</span>
                    </div>
                  </button>
                </div>
              )}
          </div>
        </div>
        {/* <div className="d-flex flex-column " style={{ marginTop: "100px" }}>
          <h1
            className="font-poppins text-2xl font-semibold "
          >
            {t("About the Event")}
          </h1>
          <h1 className="font-poppins text-lg" >
            {event?.description}
          </h1>
        </div> */}
        <div className="d-flex flex-column " style={{ marginTop: "100px" }}>
          <h1
            className=" mb-3 font-poppins text-2xl font-semibold"
          >
            {t("Media Attachments")}
          </h1>
          <h1 className="font-poppins" style={{ fontSize: "30px" }}>
            {event?.attachments && event?.attachments?.length > 0 && (
              <Attachment attachments={event?.attachments} />
            )}
          </h1>
        </div>
        <div className="d-flex flex-column" style={{ marginTop: "100px" }}>
          <h1
            className=" font-poppins text-2xl font-semibold"
          >
            {t("Location")}
          </h1>
          <div className="pt-0">
            <div>
              <div className=" descripton-content">
                <div className="d-flex">
                  <div className="date">
                    {/* <div className="location_icon">
                    <ImLocation
                      style={{
                        height: "20px",
                        width: "20px",
                        color: "#00ab44",
                      }}
                    />
                  </div> */}
                  </div>
                  <div className="col-lg-6 col-sm-12 col-md-6 date">
                    <div className="font-poppins  text-lg">{event?.address}</div>
                    <div className="font-poppins  text-lg">{event?.address2}</div>
                    <div className="col-lg-6 col-md-6 mt-4">
                      <button
                        type="submit"
                        onClick={() =>
                          window.open(
                            `https://www.google.com/maps/dir/${latlong?.lat},${latlong?.lng}/${event?.location?.coordinates[1]},${event?.location?.coordinates[0]}`,
                            "_blank"
                          )
                        }
                        className="d-flex align-items-center border-0 font-poppins text-2xl text-white text-uppercase mt-3 px-3"
                        style={{
                          cursor: "pointer",
                          height: "75px",
                          borderRadius: "10px",
                          background: "#EB7625",
                        }}
                      >
                        <TiLocationArrow
                          style={{
                            height: "40px",
                            width: "40px",
                            color: "white",
                          }}
                        />
                        <span className="text-xl">{t("Direction")}</span>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {event?.usersId !== null && event?.usersId !== undefined && (
          <div
            className="d-flex flex-column gap-3"
            style={{ marginTop: "100px" }}
          >
            <h1
              className="font-poppins text-2xl font-semibold"
            >
              {t("Event Organizer")}
            </h1>
            <div className="d-flex flex-column flex-lg-row  gap-5">
              {event?.usersId?.imageURL ? (
                <img
                  style={{ height: "170px", width: "170px", borderRadius: "50%" }}
                  src={event?.usersId?.imageURL}
                  alt=""
                />
              ) : (
                <div
                  className="d-flex justify-content-center align-items-center"
                  style={{
                    height: "170px",
                    width: "170px",
                    borderRadius: "50%",
                    background: "#EB7625",
                  }}
                >
                  <span
                    className="font-poppins text-uppercase text-white"
                    style={{ fontSize: "70px" }}
                  >
                    {event?.usersId?.firstName?.charAt(0)}
                  </span>
                </div>
              )}
              <div className="d-flex flex-column gap-3">
                <h1
                  style={{
                    fontWeight: 700,
                    marginBottom: 0,
                  }}
                  className="font-poppins text-2xl font-semibold"
                >
                  {event?.usersId?.userName}
                </h1>
                {event?.usersId?.userMob && (
                  <div className="d-flex align-items-center gap-3">
                    <div
                      className="d-flex justify-content-center align-items-center"
                      style={{
                        height: "35px",
                        width: "35px",
                        borderRadius: "50%",
                        background: "#483F50",
                      }}
                    >
                      <CallIcon />
                    </div>
                    <span>
                      <span className="font-poppins text-lg">
                        {event?.usersId?.userMob}
                      </span>
                    </span>
                  </div>
                )}

                <div className="d-flex align-items-center gap-3">
                  <div
                    className="d-flex justify-content-center align-items-center"
                    style={{
                      height: "35px",
                      width: "35px",
                      borderRadius: "50%",
                      background: "#483F50",
                    }}
                  >
                    <SmsIcon />
                  </div>
                  <span className="font-poppins text-lg">
                    {event?.usersId?.userEmail}
                  </span>
                </div>

                <a
                  href={`mailto:${event?.usersId?.userEmail}`}
                  className="text-white text-decoration-none"
                >
                  <button
                    className="mt-3 border-0 font-poppins text-xl text-white text-uppercase px-5"
                    style={{
                      cursor: "pointer",
                      height: "75px",
                      borderRadius: "10px",
                      background: "#EB7625",
                    }}
                  >
                    {t("Contact Me")}
                  </button>
                </a>
              </div>
            </div>
          </div>
        )}
        <ShareModal show={show} close={handleClose} />
        <UserList
          show={showUserList}
          close={handleCloseUserList}
          userlist={userList}
        />
        <Invited
          show={showInvited}
          close={handleCloseInvited}
          invitedUsers={invitedUsers}
          event={event}
        />
        {showCreate && (
          <NewEvent
            show={showCreate}
            close={handleCloseCreate}
            event={selectedEvent ? selectedEvent : ""}
            setSelectedEvent={setSelectedEvent}
          />
        )}
        <LoginModal
          show={showLogin}
          handleCloseLogin={() => handleCloseLogin()}
        />
      </div>
    </>
  );
};

export default SingleEvent;
